import { render, staticRenderFns } from "./PromptLogin.vue?vue&type=template&id=628cad8c"
import script from "./PromptLogin.vue?vue&type=script&lang=ts"
export * from "./PromptLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports